import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgShareNetwork = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19.25 17.5a4.362 4.362 0 0 0-3.13 1.322l-5.043-3.24a4.353 4.353 0 0 0 0-3.164l5.043-3.24a4.375 4.375 0 1 0-.948-1.471l-5.042 3.24a4.375 4.375 0 1 0 0 6.106l5.042 3.24A4.375 4.375 0 1 0 19.25 17.5Zm0-14a2.625 2.625 0 1 1 0 5.25 2.625 2.625 0 0 1 0-5.25ZM7 16.625a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25ZM19.25 24.5a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25Z" />
  </svg>
);
export default SvgShareNetwork;
